export default {
	layout: "sets",
	sets: 7,
	winnerPoints: 11,
	deuce: true,
	isIndividualSport: true,
	doesntHaveTime: true,
}
